module.exports = __webpack_public_path__ + "img/q4.d9c70eb2.png";